(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(51561);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90884:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ ProductLoop; },
  "P": function() { return /* binding */ ProductLoopLoading; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
// EXTERNAL MODULE: ./components/ui/NewGallery/index.tsx
var NewGallery = __webpack_require__(23303);
;// CONCATENATED MODULE: ./components/ui/SkeletonLoading/index.tsx


var SkeletonLoading = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " skeleton")
    });
};
/* harmony default export */ var ui_SkeletonLoading = (SkeletonLoading);

;// CONCATENATED MODULE: ./components/loop/ProductLoop.tsx







var ProductLoop = function(props) {
    var ref, ref1, ref2;
    var p = props.p, t = props.t, catCode = props.catCode, isShowOriginPrice = props.isShowOriginPrice;
    var handle = "".concat((0,app/* createHandle */.UR)(p.product_name), "-").concat(p.id, "-").concat(p.product_code);
    var isDiscount = p.product_discount ? (0,app/* checkTime */.s)((ref = p.product_discount) === null || ref === void 0 ? void 0 : ref.started_at, (ref1 = p.product_discount) === null || ref1 === void 0 ? void 0 : ref1.ended_at) : false;
    if (p.product_discount && ((ref2 = p.product_discount) === null || ref2 === void 0 ? void 0 : ref2.status) === shared/* DiscountStatus.Ended */.YT.Ended) isDiscount = false;
    var isDeposited = p.quantity <= 0 || p.status == shared/* ProductStatus.CloseASale */.Pt.CloseASale || p.status === shared/* ProductStatus.Deposited */.Pt.Deposited;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full tw-bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-border tw-border-gray-70 tw-overflow-hidden tw-w-full tw-h-full hover:tw-border-primary-main tw-duration-500 tw-ease-linear",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full p-100p tw-relative tw-leading-0 tw-h-0 tw-bg-secondary-20",
                    children: [
                        p.images && p.images.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewGallery/* default */.Z, {
                                images: p.images
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                            className: "tw-w-full tw-h-full !tw-absolute tw-z-1 tw-top-0 tw-left-0 tw-bottom-0",
                            alt: p.product_name,
                            src: p.images && p.images[0] ? p.images[0].url : "/bg-default.png"
                        }),
                        p.product_discount && isDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/sale.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "sale"
                                })
                            })
                        }),
                        p.is_auction && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-w-7 tw-h-7 tw-absolute tw-top-3 tw-right-3 tw-z-10",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/auction.png",
                                    className: "tw-w-full tw-h-full",
                                    alt: "auction"
                                })
                            })
                        }),
                        isDeposited && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-absolute tw-z-10",
                            style: {
                                top: "8px",
                                left: "0"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PentagonIcon */.nM, {
                                    text: "Đ\xe3 b\xe1n"
                                }),
                                " "
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5",
                    children: [
                        catCode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.CategoryProductPage */._.CategoryProductPage,
                                query: {
                                    id: catCode,
                                    slug: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                            url: {
                                pathname: shared/* PagePath.ProductDetailPage */._.ProductDetailPage,
                                query: {
                                    id: handle
                                }
                            },
                            className: "tw-h-12 md:tw-h-12 tw-px-1 tw-text-base tw-font-semibold tw-text-primary-main tw-w-full tw-line-clamp-2 tw-text-center",
                            children: p.product_name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-secondary-81 tw-font-light tw-text-sm md:tw-text-base tw-line-clamp-1 tw-px-1",
                                    children: p.product_code
                                }),
                                p.quotation ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "tw-text-secondary-70",
                                    children: "Li\xean hệ"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: p.is_auction && p.auction ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                            children: (0,app/* toMoney */.KP)(p.auction.status === shared/* AuctionStatus.Pending */.wo.Pending ? p.auction.origin_price || 0 : p.auction.sell_price || 0, t, shared/* PriceSymbol.$ */.hb.$)
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: p.product_discount && isDiscount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                isShowOriginPrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-block tw-mt-1 tw-text-secondary-81 tw-font-light tw-text-sm tw-line-through tw-italic",
                                                    children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                                }) : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                                    children: (0,app/* toMoney */.KP)(p.price - p.price * p.product_discount.discount / 100, t, shared/* PriceSymbol.$ */.hb.$)
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "tw-text-md tw-block tw-mt-1 tw-text-secondary-70 tw-font-semibold",
                                                children: (0,app/* toMoney */.KP)(p.price, t, shared/* PriceSymbol.$ */.hb.$)
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var ProductLoopLoading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-full tw-bg-white tw-border tw-border-gray-70",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-flex tw-flex-col tw-rounded-5 tw-overflow-hidden tw-w-full tw-h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-w-full p-100p tw-relative tw-h-0 ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                        className: "tw-w-full tw-h-full tw-absolute tw-top-0 tw-left-0"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-pt-4 tw-pb-5 tw-px-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                            className: "tw-h-12 md:tw-h-12 tw-rounded"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-center tw-mt-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                                    className: "tw-h-6 tw-rounded"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_SkeletonLoading, {
                                    className: "tw-h-6 tw-mt-1 tw-rounded"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 27590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F7": function() { return /* binding */ useFetchCategoryProducts; },
/* harmony export */   "i7": function() { return /* binding */ useFetchPartnersForBanner; },
/* harmony export */   "jR": function() { return /* binding */ useFetchNewsQuery; },
/* harmony export */   "vh": function() { return /* binding */ useFetchFlashSale; }
/* harmony export */ });
/* unused harmony exports fetchMasterData, fetchMasterDataByKey, fetchBanners, fetchPartners, fetchNews, fetchCategoryProducts, fetchFlashSale */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _layouts_shared__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7806);
/* harmony import */ var _libs_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80787);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);





var fetchMasterData = function() {
    return axios.get("/api/v1/masterdata/list");
};
var fetchMasterDataByKey = function(key) {
    return axios.get("/api/v1/masterdata/".concat(key));
};
var fetchBanners = function() {
    return axios.get("/api/v1/banner", {
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        }
    });
};
var fetchPartners = function() {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/partner/banners");
};
var fetchNews = function(params) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* .instanceNews.get */ .iR.get("/wp-json/wp/v2/posts", {
        params: params
    });
};
var fetchCategoryProducts = function(code) {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/products/category/".concat(code, "/list"));
};
var fetchFlashSale = function() {
    return _libs_axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get("/api/v1/products/flash-sale");
};
var useFetchNewsQuery = function(payload, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.News */ .S8.News,
        payload
    ], function(param) {
        var queryKey = param.queryKey;
        var _queryKey = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(queryKey, 2), params = _queryKey[1];
        return fetchNews(params);
    }, options);
};
var useFetchCategoryProducts = function(code, options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.ProductCategory */ .S8.ProductCategory,
        code
    ], function() {
        return fetchCategoryProducts(code);
    }, options);
};
var useFetchFlashSale = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.FlashSale */ .S8.FlashSale
    ], function() {
        return fetchFlashSale();
    }, options);
};
var useFetchPartnersForBanner = function(options) {
    return (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _layouts_shared__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.PartnersForBanner */ .S8.PartnersForBanner
    ], function() {
        return fetchPartners();
    }, options);
};


/***/ }),

/***/ 51561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/ui/MetaTag/index.tsx
var MetaTag = __webpack_require__(42031);
// EXTERNAL MODULE: ./components/index.ts + 87 modules
var components = __webpack_require__(83554);
// EXTERNAL MODULE: ./layouts/shared.ts
var shared = __webpack_require__(7806);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
;// CONCATENATED MODULE: ./features/home/partials/Categories/index.tsx






var ListCategories = function(param) {
    var categories = param.categories;
    var listCategories = categories.filter(function(c) {
        return c.images && !c.hide_menu;
    });
    var swiperRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container tw-flex tw-justify-center tw-relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "custom-prev tw-hidden tw-w-10 tw-h-10 tw-rounded-full tw-absolute tw-top-1/4 tw-left-0 md:tw-flex tw-items-center tw-justify-center tw-z-10 tw-text-primary-main",
                onClick: function() {
                    var ref;
                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                    className: "tw-w-full tw-h-full",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-11/12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    slidesPerView: 7,
                    spaceBetween: 16,
                    keyboard: {
                        enabled: true
                    },
                    pagination: {
                        clickable: true
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 3.5,
                            spaceBetween: 8
                        },
                        768: {
                            slidesPerView: 5,
                            spaceBetween: 16
                        },
                        1024: {
                            slidesPerView: 7,
                            spaceBetween: 16
                        }
                    },
                    // loop={true}
                    // navigation={false}
                    onBeforeInit: function(swiper) {
                        swiperRef.current = swiper;
                    },
                    modules: [
                        swiper_esm/* EffectFade */.xW,
                        swiper_esm/* Navigation */.W_
                    ],
                    className: "product-loop-swiper tw-overflow-auto category-scrollbar",
                    id: "swiper",
                    children: listCategories.map(function(item, key) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            className: "tw-relative tw-pb-2 tw-overflow-auto after:tw-absolute after:tw-w-8/12 after:tw-h-[2px] after:tw-bg-primary-main after:tw-bottom-0 after:tw-left-1/2 after:tw--translate-x-1/2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                url: {
                                    pathname: shared/* PagePath.CategoryPage */._.CategoryPage,
                                    query: {
                                        id: item.code
                                    }
                                },
                                className: "tw-flex tw-justify-center tw-items-center tw-flex-col tw-space-y-2 ",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-w-[60px] tw-h-[60px] lg:tw-w-[100px] lg:tw-h-[100px] tw-rounded-full tw-overflow-hidden ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: ((ref = item.images) === null || ref === void 0 ? void 0 : ref.url) || "",
                                            className: "tw-w-full tw-h-full",
                                            alt: item.product_category_name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "tw-text-sm md:tw-text-md tw-line-clamp-1 tw-w-full tw-text-center tw-mt-3 tw-text-secondary-70",
                                        children: item.product_category_name
                                    })
                                ]
                            })
                        }, "item-".concat(key));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "custom-next tw-hidden tw-w-10 tw-h-10 tw-absolute tw-right-0 tw-top-1/4 tw-text-primary-main md:tw-flex tw-items-center tw-justify-center tw-rotate-180 tw-z-10",
                onClick: function() {
                    var ref;
                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                    className: "tw-w-full tw-h-full",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                })
            })
        ]
    });
};
/* harmony default export */ var Categories = (/*#__PURE__*/(0,react.memo)(ListCategories));

;// CONCATENATED MODULE: ./features/home/const.ts
var SliderMediaType;
(function(SliderMediaType) {
    SliderMediaType["Image"] = "IMAGE";
    SliderMediaType["Video"] = "VIDEO";
})(SliderMediaType || (SliderMediaType = {}));

// EXTERNAL MODULE: ./node_modules/react-player/lib/index.js
var lib = __webpack_require__(22004);
;// CONCATENATED MODULE: ./features/home/partials/HomeSlider/index.tsx





var HomeSlider = function(param) {
    var images = param.images;
    var ref = (0,react.useState)(1), slideIndex = ref[0], setSlideIndex = ref[1];
    var ref1 = (0,react.useState)(""), videoHeight = ref1[0], setVideoHeight = ref1[1];
    var refDiv = (0,react.useRef)(null);
    var playerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            var ref;
            if (((ref = (images !== null && images !== void 0 ? images : [])[slideIndex - 1]) === null || ref === void 0 ? void 0 : ref.media_type) === SliderMediaType.Image) {
                if (slideIndex < images.length) {
                    setSlideIndex(function(slideIndex) {
                        return slideIndex + 1;
                    });
                } else if (slideIndex === images.length) {
                    setSlideIndex(1);
                }
            }
        }, 5000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        slideIndex,
        images
    ]);
    (0,react.useEffect)(function() {
        if (refDiv) {
            var ref;
            setVideoHeight(refDiv === null || refDiv === void 0 ? void 0 : (ref = refDiv.current) === null || ref === void 0 ? void 0 : ref.clientHeight);
        }
    }, []);
    var moveDot = function(index) {
        setSlideIndex(index);
    };
    var playerConfig = {
        attributes: {
            with: 2000
        },
        youtube: {
            playerVars: {
                autoplay: 1,
                mute: 1,
                controls: 0,
                modestbranding: 1,
                rel: 0,
                showinfo: 0
            }
        }
    };
    var items = Array.isArray(images) ? images : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-w-full tw-h-full tw-relative tw-flex tw-pb-40-percent md:tw-pb-35-percent",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: refDiv,
                    className: "tw-w-full tw-h-full home-slider tw-relative",
                    children: items.map(function(item, index) {
                        var ref;
                        var ref1;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-w-full tw-bg-center tw-bg-cover tw-absolute tw-top-0 tw-left-0 tw-bottom-0  tw-pb-40-percent md:tw-pb-35-percent ".concat(slideIndex === index + 1 ? "slider-item active" : "slider-item tw-hidden"),
                            children: [
                                item.media_type === SliderMediaType.Image && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                    url: (ref1 = (ref = images[slideIndex - 1]) === null || ref === void 0 ? void 0 : ref.link) !== null && ref1 !== void 0 ? ref1 : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: item.image_url,
                                        alt: item.title,
                                        priority: slideIndex === index + 1 ? true : false,
                                        className: "tw-w-full tw-h-full !tw-absolute tw-top-0 tw-left-0"
                                    })
                                }),
                                item.media_type === SliderMediaType.Video && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "video-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        url: item.video_url,
                                        width: "100%",
                                        height: "100%",
                                        className: "react-player home-slider-video tw-w-full tw-h-full !tw-absolute tw-top-0 tw-left-0",
                                        ref: playerRef,
                                        autoPlay: true,
                                        playing: slideIndex === index + 1,
                                        loop: true,
                                        controls: true,
                                        config: playerConfig
                                    })
                                })
                            ]
                        }, item.title + "-" + index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-absolute slider-index-dots tw-gap-x-2 md:tw-gap-x-3 tw-flex",
                    children: items.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return moveDot(index + 1);
                            },
                            className: "tw-w-2 tw-h-2 md:tw-w-4 md:tw-h-4 tw-rounded-full ".concat(slideIndex === index + 1 ? "tw-bg-primary-main" : "tw-bg-white")
                        }, item.title + "-" + index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var partials_HomeSlider = (/*#__PURE__*/(0,react.memo)(HomeSlider));

// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/react-hot-toast.esm.js + 1 modules
var react_hot_toast_esm = __webpack_require__(74931);
// EXTERNAL MODULE: ./components/loop/ProductLoop.tsx + 1 modules
var ProductLoop = __webpack_require__(90884);
// EXTERNAL MODULE: ./features/home/api.ts
var api = __webpack_require__(27590);
;// CONCATENATED MODULE: ./features/home/partials/NewProducts/index.tsx









var NewProduct = function(param) {
    var catCode = param.catCode, t = param.t, title = param.title, theme = param.theme, _isSale = param.isSale, isSale = _isSale === void 0 ? false : _isSale;
    var ref;
    var ref1 = (0,react.useState)(), category = ref1[0], setCategory = ref1[1];
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    var refetch = (0,api/* useFetchCategoryProducts */.F7)(catCode, {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            return react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            return setCategory(data);
        }
    }).refetch;
    (0,react.useEffect)(function() {
        refetch();
    }, [
        refetch
    ]);
    var swiperRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-justify-between tw-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-flex-1 tw-relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-w-max tw-justify-center ",
                            children: [
                                icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: icon_category_url,
                                    alt: "star",
                                    className: "tw-h-8 tw-w-8"
                                }),
                                !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: isSale ? "/sale.gif" : "/diamond.svg",
                                    alt: "star",
                                    className: "tw-h-5 tw-w-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold",
                                    children: title
                                }),
                                !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: isSale ? "/sale.gif" : "/diamond.svg",
                                    alt: "star",
                                    className: "tw-h-5 tw-w-5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-center tw-text-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                            className: "tw-italic tw-text-center tw-flex tw-items-center tw-w-max !tw-text-secondary-70",
                            url: {
                                pathname: shared/* PagePath.CategoryPage */._.CategoryPage,
                                query: {
                                    id: catCode
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Xem th\xeam"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: "tw-w-4 tw-h-4 tw-rotate-180 tw-ml-2",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mt-8 tw-w-full tw-h-full tw-leading-0 tw-relative tw-pb-[40%]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                    className: "tw-italic tw-text-center tw-flex tw-items-center tw-w-max !tw-text-secondary-70",
                    url: {
                        pathname: shared/* PagePath.CategoryPage */._.CategoryPage,
                        query: {
                            id: catCode
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                        className: "tw-w-full tw-h-full !tw-absolute tw-left-0 tw-top-0",
                        src: category === null || category === void 0 ? void 0 : (ref = category.banner_images) === null || ref === void 0 ? void 0 : ref.url,
                        alt: category === null || category === void 0 ? void 0 : category.product_category_name
                    })
                })
            }),
            (category === null || category === void 0 ? void 0 : category.products) && (category === null || category === void 0 ? void 0 : category.products.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-block tw-relative tw-mt-8 lg:tw-mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "tw-hidden custom-prev tw-w-10 tw-h-10 tw-rounded-full tw-absolute tw-top-1/4 tw--left-10 lg:tw-flex tw-items-center tw-justify-center tw-z-10 tw-text-primary-main",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            className: "tw-w-full tw-h-full",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                        slidesPerView: 4,
                        spaceBetween: 16,
                        keyboard: {
                            enabled: true
                        },
                        pagination: {
                            clickable: true
                        },
                        breakpoints: {
                            0: {
                                slidesPerView: 2.5,
                                spaceBetween: 8
                            },
                            768: {
                                slidesPerView: 3.5,
                                spaceBetween: 16
                            },
                            1024: {
                                slidesPerView: 4,
                                spaceBetween: 16
                            }
                        },
                        onBeforeInit: function(swiper) {
                            swiperRef.current = swiper;
                        },
                        modules: [
                            swiper_esm/* EffectFade */.xW,
                            swiper_esm/* Navigation */.W_
                        ],
                        className: "product-loop-swiper tw-overflow-auto category-scrollbar",
                        id: "swiper",
                        children: category && category.products.map(function(item, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                className: "tw-relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop/* ProductLoop */._, {
                                    catCode: item.cat_code,
                                    p: item,
                                    t: t
                                })
                            }, "item-".concat(key));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "custom-next tw-hidden tw-w-10 tw-h-10 tw-absolute tw--right-10 tw-top-1/4 tw-text-primary-main lg:tw-flex tw-items-center tw-justify-center tw-rotate-180 tw-z-10",
                        onClick: function() {
                            var ref;
                            return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                            className: "tw-w-full tw-h-full",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var NewProducts = (NewProduct);

// EXTERNAL MODULE: ./libs/app/index.ts
var app = __webpack_require__(92517);
;// CONCATENATED MODULE: ./features/home/partials/Partners/PartnerCard.tsx





var PartnerCard = function(props) {
    var ref, ref1, ref2;
    var partner = props.partner;
    var avatarUrl = partner === null || partner === void 0 ? void 0 : partner.avatar;
    var bannerUrl = partner === null || partner === void 0 ? void 0 : (ref = partner.partner_stores) === null || ref === void 0 ? void 0 : (ref1 = ref.banner_image) === null || ref1 === void 0 ? void 0 : ref1.url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
        url: {
            pathname: shared/* PagePath.PartnerDetail */._.PartnerDetail,
            query: {
                id: partner.id
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-h-[320px] tw-border tw-border-gray-70 hover:tw-border-primary-main tw-bg-white tw-rounded-3xl tw-overflow-hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-h-[150px] tw-bg-center tw-bg-cover tw-bg-no-repeat tw-relative",
                    style: {
                        backgroundImage: "url(".concat(bannerUrl, ")")
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-left-3 tw-bottom-3 tw-z-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                src: avatarUrl,
                                className: "tw-w-20 tw-h-20",
                                rounded: "tw-rounded-full"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-absolute tw-left-0 tw-top-0 tw-w-full tw-h-full",
                            style: {
                                background: "linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.46))"
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "tw-text-primary-main tw-font-bold",
                            children: partner.fullname
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-font-medium",
                            children: (0,app/* toPhoneNumberNational */._J)(partner.phone, partner.country, true)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "tw-text-secondary-81 tw-text-[14px] tw-leading-7 tw-font-medium tw-whitespace-pre-wrap tw-line-clamp-3",
                            children: (ref2 = partner.partner_stores) === null || ref2 === void 0 ? void 0 : ref2.description
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Partners_PartnerCard = (PartnerCard);

;// CONCATENATED MODULE: ./features/home/partials/Partners/index.tsx







var PartnersPartial = function(props) {
    var title = props.title;
    var ref = (0,react.useState)([]), partners = ref[0], setPartners = ref[1];
    var ref1 = (0,api/* useFetchPartnersForBanner */.i7)({
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            return setPartners(data.data);
        }
    }), fetchPartners = ref1.refetch, isLoadingNews = ref1.isLoading;
    (0,react.useEffect)(function() {
        fetchPartners();
    }, [
        fetchPartners
    ]);
    var swiperRef = (0,react.useRef)();
    if (!(partners === null || partners === void 0 ? void 0 : partners.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full tw-h-[540px] md:tw-h-[380px] tw-bg-cover tw-grid tw-gr",
        style: {
            backgroundImage: 'url("/bg-partner-section.png")'
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container tw-mx-auto tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-pt-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:tw-pr-6 ".concat(partners.length === 1 && "tw-col-span-1 md:tw-col-span-2"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-flex-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tw-flex tw-items-center tw-w-max tw-justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/handshake.svg",
                                        alt: "handshake",
                                        className: "tw-h-6 tw-w-6"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        src: "/handshake.svg",
                                        alt: "handshake",
                                        className: "tw-h-6 tw-w-6"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-text-secondary-70 tw-font-medium tw-pt-6 tw-leading-7",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "An Thư Diamond Store tự h\xe0o hợp t\xe1c c\xf9ng những doanh nghiệp kim ho\xe0n h\xe0ng đầu, mang đến những sản phẩm chất lượng cao v\xe0 đa dạng."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-col-span-1 md:tw-col-span-2 ".concat(partners.length === 1 && "md:!tw-col-span-1"),
                    children: (partners === null || partners === void 0 ? void 0 : partners.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-block tw-relative md:tw-mt-4",
                        children: [
                            partners.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "tw-hidden custom-prev tw-w-10 tw-h-10 tw-rounded-full tw-absolute tw-top-1/2 -tw-translate-y-[50%] tw--left-10 lg:tw-flex tw-items-center tw-justify-center tw-z-10 tw-text-primary-main",
                                onClick: function() {
                                    var ref;
                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: "tw-w-full tw-h-full",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                slidesPerView: partners.length === 1 ? 1 : 2,
                                spaceBetween: 16,
                                keyboard: {
                                    enabled: true
                                },
                                pagination: {
                                    clickable: true
                                },
                                breakpoints: {
                                    0: {
                                        slidesPerView: partners.length === 1 ? 1 : 1.5,
                                        spaceBetween: 8
                                    },
                                    768: {
                                        slidesPerView: partners.length === 1 ? 1 : 2,
                                        spaceBetween: 16
                                    },
                                    1024: {
                                        slidesPerView: partners.length === 1 ? 1 : 2,
                                        spaceBetween: 16
                                    }
                                },
                                onBeforeInit: function(swiper) {
                                    swiperRef.current = swiper;
                                },
                                modules: [
                                    swiper_esm/* EffectFade */.xW,
                                    swiper_esm/* Navigation */.W_
                                ],
                                className: "product-loop-swiper tw-overflow-auto category-scrollbar",
                                id: "swiper",
                                children: partners === null || partners === void 0 ? void 0 : partners.map(function(item, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        className: "tw-relative ".concat(partners.length === 1 && "tw-flex-1"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners_PartnerCard, {
                                            partner: item
                                        })
                                    }, "item-".concat(index));
                                })
                            }),
                            partners.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "custom-next tw-hidden tw-w-10 tw-h-10 tw-absolute tw--right-10 tw-top-1/2 -tw-translate-y-[50%] tw-text-primary-main lg:tw-flex tw-items-center tw-justify-center tw-rotate-180 tw-z-10",
                                onClick: function() {
                                    var ref;
                                    return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: "tw-w-full tw-h-full",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Partners = (PartnersPartial);

;// CONCATENATED MODULE: ./features/home/partials/FlashSale/CountDown.tsx



var CountDown = function(param) {
    var startTime = param.startTime, endTime = param.endTime, handleCountDown = param.handleCountDown, t = param.t;
    var countDownDate = new Date(endTime).getTime();
    var ref = (0,react.useState)(true), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)("0"), hours = ref1[0], setHours = ref1[1];
    var ref2 = (0,react.useState)("0"), minute = ref2[0], setMinute = ref2[1];
    var ref3 = (0,react.useState)("0"), second = ref3[0], setSecond = ref3[1];
    (0,react.useEffect)(function() {
        setShow(true);
        var distance = 0;
        var interval = setInterval(function() {
            var now = (0,app/* parseUtcTime */.Ec)();
            distance = countDownDate - now;
            distance = distance < 0 ? 0 : distance;
            setHours((0,app/* pad */.vk)(Math.floor(distance / (1000 * 60 * 60))));
            setMinute((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60 * 60) / (1000 * 60))));
            setSecond((0,app/* pad */.vk)(Math.floor(distance % (1000 * 60) / 1000)));
            if (Math.round(distance / 1000) <= 0) {
                setShow(false);
                clearInterval(interval);
                handleCountDown && handleCountDown();
            }
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        endTime
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-text-white tw-flex tw-gap-x-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border-primary-main tw-bg-primary-main tw-border tw-text-white tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-lg tw-rounded-5 tw-w-8 tw-h-8",
                        children: hours
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-text-primary-main tw-text-lg",
                    children: ":"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border-primary-main tw-bg-primary-main tw-border tw-text-white tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-lg tw-rounded-5 tw-w-8 tw-h-8",
                        children: minute
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-text-primary-main tw-text-lg",
                    children: ":"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex tw-flex-col tw-text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-border-primary-main tw-bg-primary-main tw-border tw-text-white tw-font-semibold tw-flex tw-items-center tw-justify-center tw-text-lg tw-rounded-5 tw-w-8 tw-h-8",
                        children: second
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./features/home/partials/FlashSale/index.tsx











var FlashSale = function(param) {
    var title = param.title, theme = param.theme, t = param.t;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    var ref = (0,react.useState)([]), flashSaleProducts = ref[0], setFlashSaleProducts = ref[1];
    var ref1 = (0,react.useState)(dayjs_min_default()().toISOString()), startTime = ref1[0], setStartTime = ref1[1];
    var ref2 = (0,react.useState)(dayjs_min_default()().toISOString()), endTime = ref2[0], setEndTime = ref2[1];
    var swiperRef = (0,react.useRef)();
    var refetch = (0,api/* useFetchFlashSale */.vh)({
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            return react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            setFlashSaleProducts(data.products);
            setStartTime(data.started_at);
            setEndTime(data.ended_at);
        }
    }).refetch;
    (0,react.useEffect)(function() {
        refetch();
        var interval = setInterval(function() {
            refetch();
        }, 60000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        refetch
    ]);
    if (!(flashSaleProducts === null || flashSaleProducts === void 0 ? void 0 : flashSaleProducts.length)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "container tw-mx-auto tw-mb-5 md:tw-mb-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-justify-between tw-items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-flex-1 tw-relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-items-center tw-w-max tw-justify-center ",
                                    children: [
                                        icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: icon_category_url,
                                            alt: "star",
                                            className: "tw-h-8 tw-w-8"
                                        }),
                                        !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/diamond.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold",
                                            children: title
                                        }),
                                        !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                            src: "/diamond.svg",
                                            alt: "star",
                                            className: "tw-h-5 tw-w-5"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-hidden md:tw-block",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                                        startTime: startTime,
                                        endTime: endTime,
                                        t: t,
                                        handleCountDown: function() {
                                            setTimeout(function() {
                                                return refetch();
                                            }, 2000);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-text-center tw-text-md",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                className: "tw-italic tw-text-center tw-flex tw-items-center tw-w-max !tw-text-secondary-70",
                                url: {
                                    pathname: shared/* PagePath.CategoryPage */._.CategoryPage,
                                    query: {
                                        id: "FLASHSALE"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Xem th\xeam"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                        className: "tw-w-4 tw-h-4 tw-rotate-180 tw-ml-2",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tw-flex md:tw-hidden tw-justify-end tw-mt-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                        startTime: startTime,
                        endTime: endTime,
                        t: t,
                        handleCountDown: function() {
                            setTimeout(function() {
                                return refetch();
                            }, 2000);
                        }
                    })
                }),
                flashSaleProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-block tw-relative tw-mt-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "tw-hidden custom-prev tw-w-10 tw-h-10 tw-rounded-full tw-absolute tw-top-1/4 tw--left-10 lg:tw-flex tw-items-center tw-justify-center tw-z-10 tw-text-primary-main",
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: "tw-w-full tw-h-full",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            slidesPerView: 4,
                            spaceBetween: 16,
                            keyboard: {
                                enabled: true
                            },
                            pagination: {
                                clickable: true
                            },
                            breakpoints: {
                                0: {
                                    slidesPerView: 2.5,
                                    spaceBetween: 8
                                },
                                768: {
                                    slidesPerView: 3.5,
                                    spaceBetween: 16
                                },
                                1024: {
                                    slidesPerView: 4,
                                    spaceBetween: 16
                                }
                            },
                            onBeforeInit: function(swiper) {
                                swiperRef.current = swiper;
                            },
                            modules: [
                                swiper_esm/* EffectFade */.xW,
                                swiper_esm/* Navigation */.W_
                            ],
                            className: "product-loop-swiper tw-overflow-auto category-scrollbar",
                            id: "swiper",
                            children: flashSaleProducts.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "tw-relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop/* ProductLoop */._, {
                                        isShowOriginPrice: true,
                                        catCode: item.cat_code,
                                        p: item,
                                        t: t
                                    })
                                }, "item-".concat(key));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "custom-next tw-hidden tw-w-10 tw-h-10 tw-absolute tw--right-10 tw-top-1/4 tw-text-primary-main lg:tw-flex tw-items-center tw-justify-center tw-rotate-180 tw-z-10",
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                className: "tw-w-full tw-h-full",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var partials_FlashSale = (FlashSale);

// EXTERNAL MODULE: ./libs/dayjs/index.ts
var dayjs = __webpack_require__(74865);
;// CONCATENATED MODULE: ./features/home/partials/Articles/index.tsx






var ArticlesPartial = function(param) {
    var title = param.title, t = param.t, id = param.id, slug = param.slug, theme = param.theme;
    var icon_category_url = (theme !== null && theme !== void 0 ? theme : {}).icon_category_url;
    var ref = (0,react.useState)([]), articles = ref[0], setArticles = ref[1];
    var ref1 = (0,api/* useFetchNewsQuery */.jR)({
        page: 1,
        per_page: 4,
        categories: id
    }, {
        enabled: false,
        refetchOnWindowFocus: false,
        onSuccess: function(data) {
            return setArticles(data.data);
        }
    }), refetchNews = ref1.refetch, isLoadingNews = ref1.isLoading;
    (0,react.useEffect)(function() {
        refetchNews();
    }, [
        refetchNews,
        articles
    ]);
    var firstArticle = articles[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-w-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-justify-between tw-items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-flex-1 tw-relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-items-center tw-w-max tw-justify-center ",
                            children: [
                                icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: icon_category_url,
                                    alt: "star",
                                    className: "tw-h-8 tw-w-8"
                                }),
                                !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/diamond.svg",
                                    alt: "star",
                                    className: "tw-h-5 tw-w-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold",
                                    children: title
                                }),
                                !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                    src: "/diamond.svg",
                                    alt: "star",
                                    className: "tw-h-5 tw-w-5"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-text-center tw-text-md",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                            className: "tw-italic tw-text-center tw-flex tw-items-center tw-w-max !tw-text-secondary-70",
                            url: {
                                pathname: shared/* PagePath.BlogPage */._.BlogPage,
                                query: {
                                    id: slug
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Xem th\xeam"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                    className: "tw-w-4 tw-h-4 tw-rotate-180 tw-ml-2",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-w-full tw-justify-center tw-flex tw-gap-x-5 tw-mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-w-full p-100p tw-bg-center tw-bg-cover tw-relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-absolute tw-w-full tw-h-full tw-top-0 tw-right-0 tw-bottom-0 tw-z-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                        className: "tw-w-full tw-h-full",
                                        src: firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.thumbnail_url,
                                        alt: firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.title.rendered
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-w-full tw-absolute tw-left-0 tw-bottom-0 tw-bg-black tw-bg-opacity-30 tw-px-4 tw-py-3 md:tw-px-6 md:tw-py-4 tw-text-white",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-italic tw-text-sm md:tw-text-xl tw-font-light",
                                            children: (0,dayjs/* humanTimeArticle */.KM)(new Date(firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.modified) + "", "")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                            url: {
                                                pathname: shared/* PagePath.ArticlePage */._.ArticlePage,
                                                query: {
                                                    id: firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.slug
                                                }
                                            },
                                            className: "tw-mt-1 md:tw-mt-3 tw-text-md md:tw-text-2xl tw-font-bold tw-line-clamp-1 !tw-text-white",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.title.rendered
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-mt-3 md:tw-mt-5 tw-text-base md:tw-text-xl tw-font-normal tw-line-clamp-3 md:!tw-h-20 tw-overflow-hidden",
                                            dangerouslySetInnerHTML: {
                                                __html: firstArticle === null || firstArticle === void 0 ? void 0 : firstArticle.excerpt.rendered
                                            },
                                            style: {
                                                height: "70px"
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-w-full tw-flex tw-gap-y-4 tw-flex-col",
                            children: articles === null || articles === void 0 ? void 0 : articles.map(function(article, index) {
                                if ([
                                    1,
                                    2,
                                    3
                                ].includes(index)) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-grid tw-grid-cols-3 md:tw-grid-cols-2 tw-gap-4 lg:tw-gap-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                            url: {
                                                pathname: shared/* PagePath.ArticlePage */._.ArticlePage,
                                                query: {
                                                    id: article.slug
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-hidden md:tw-block tw-bg-cover tw-w-full tw-bg-center p-66p tw-relative",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-absolute tw-w-full tw-h-full tw-top-0 tw-right-0 tw-bottom-0 tw-z-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                            className: "tw-w-full tw-h-full",
                                                            src: article.thumbnail_url,
                                                            alt: article === null || article === void 0 ? void 0 : article.title.rendered
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-block md:tw-hidden tw-bg-cover tw-w-full tw-bg-center p-100p tw-relative",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-absolute tw-w-full tw-h-full tw-top-0 tw-right-0 tw-bottom-0 tw-z-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                            className: "tw-w-full tw-h-full",
                                                            src: article.thumbnail_url,
                                                            alt: article === null || article === void 0 ? void 0 : article.title.rendered
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "tw-col-span-2 md:tw-col-span-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Link */.rU, {
                                                    className: "tw-text-base md:tw-text-md",
                                                    url: {
                                                        pathname: shared/* PagePath.ArticlePage */._.ArticlePage,
                                                        query: {
                                                            id: article.slug
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "tw-line-clamp-2 tw-font-bold",
                                                        dangerouslySetInnerHTML: {
                                                            __html: article === null || article === void 0 ? void 0 : article.title.rendered
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-text-xs md:tw-text-base tw-italic tw-font-light tw-text-secondary-70 tw-mt-1",
                                                    children: (0,dayjs/* humanTimeArticle */.KM)(new Date(article === null || article === void 0 ? void 0 : article.modified) + "", "")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "tw-text-xs md:tw-text-base tw-text-secondary-70 tw-font-normal tw-mt-1 md:tw-mt-2 tw-line-clamp-2 tw-h-8 md:tw-h-12 tw-overflow-hidden",
                                                    dangerouslySetInnerHTML: {
                                                        __html: article === null || article === void 0 ? void 0 : article.excerpt.rendered
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }, "atr-" + index);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Articles = (/*#__PURE__*/(0,react.memo)(ArticlesPartial));

// EXTERNAL MODULE: ./features/livestream/detail/api.ts
var detail_api = __webpack_require__(77910);
;// CONCATENATED MODULE: ./features/home/partials/NewLive/index.tsx










var NewLive = function(param) {
    var t = param.t, title = param.title, theme = param.theme;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = theme !== null && theme !== void 0 ? theme : {}, icon_category_url = ref10.icon_category_url, web_bg_livestream_url = ref10.web_bg_livestream_url;
    var ref11 = (0,react.useState)([]), videos = ref11[0], setVideos = ref11[1];
    var ref12 = (0,react.useState)(), category = ref12[0], setCategory = ref12[1];
    var ref13 = (0,detail_api/* useFetchLiveVideosHomeQuery */.gS)({}, {
        enabled: false,
        refetchOnWindowFocus: false,
        onError: function(param) {
            var message = param.message;
            react_hot_toast_esm/* default.error */.ZP.error(message);
        },
        onSuccess: function(param) {
            var data = param.data;
            setVideos(data);
        }
    }), refetchVideos = ref13.refetch;
    var ref14 = (0,api/* useFetchCategoryProducts */.F7)("MOI", {
        onSuccess: function(param) {
            var data = param.data;
            return setCategory(data);
        }
    }), refetchProducts = ref14.refetch;
    (0,react.useEffect)(function() {
        refetchVideos();
    }, [
        refetchVideos
    ]);
    (0,react.useEffect)(function() {
        refetchProducts();
    }, [
        refetchProducts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "new-videos tw-py-8 lg:tw-py-12 tw-bg-center tw-bg-cover tw-bg-no-repeat tw-mt-10",
            style: {
                backgroundImage: web_bg_livestream_url ? "url(".concat(web_bg_livestream_url, ")") : 'url("/bg-live.svg")'
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container tw-mx-auto ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-flex tw-justify-between tw-items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-lg md:tw-text-2xl tw-flex tw-items-center tw-flex-1 tw-relative",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "tw-flex tw-items-center tw-w-max tw-justify-center ",
                                        children: [
                                            icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                src: icon_category_url,
                                                alt: "star",
                                                className: "tw-h-8 tw-w-8"
                                            }),
                                            !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                src: "/diamond.svg",
                                                alt: "star",
                                                className: "tw-h-5 tw-w-5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "tw-flex-1 tw-block tw-px-4 tw-uppercase tw-text-primary-main tw-font-semibold",
                                                children: title
                                            }),
                                            !icon_category_url && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                src: "/diamond.svg",
                                                alt: "star",
                                                className: "tw-h-5 tw-w-5"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-text-center tw-text-md",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                        className: "tw-italic tw-text-center tw-flex tw-items-center tw-w-max !tw-text-secondary-70",
                                        url: {
                                            pathname: shared/* PagePath.LiveVideosPage */._.LiveVideosPage
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Xem th\xeam"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Icon */.JO, {
                                                className: "tw-w-4 tw-h-4 tw-rotate-180 tw-ml-2",
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ArrowLeftIcon */.Y4, {})
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 tw-mt-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Link */.rU, {
                                    url: {
                                        pathname: shared/* PagePath.LiveVideoPage */._.LiveVideoPage,
                                        query: {
                                            id: "".concat((0,app/* createHandle */.UR)((ref = videos[0]) === null || ref === void 0 ? void 0 : ref.name), "-").concat((ref1 = videos[0]) === null || ref1 === void 0 ? void 0 : ref1.id)
                                        }
                                    },
                                    className: "tw-bg-white tw-border tw-rounded-sm tw-border-gray-70 tw-flex tw-flex-col tw-overflow-hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-relative tw-flex-1 tw-min-h-[200px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Image */.Ee, {
                                                className: "tw-w-full tw-h-full",
                                                objectFit: "cover",
                                                src: (0,app/* getLiveVideoImage */.eQ)((ref2 = videos[0]) === null || ref2 === void 0 ? void 0 : ref2.images),
                                                alt: (ref3 = videos[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "md:tw-px-6 md:tw-py-4 tw-px-4 tw-py-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-flex tw-items-center",
                                                    children: [
                                                        ((ref4 = videos[0]) === null || ref4 === void 0 ? void 0 : ref4.status) === shared/* LiveStreamStatus.LiveNow */.r$.LiveNow && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-py-1 tw-px-4 tw-flex tw-items-center tw-bg-[#CA3A31] tw-text-white tw-rounded-md",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "tw-w-2 tw-h-2 tw-rounded-full tw-bg-white tw-mr-2"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "Live"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "tw-ml-4 tw-font-bold",
                                                            children: (ref5 = videos[0]) === null || ref5 === void 0 ? void 0 : ref5.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "tw-mt-3 tw-flex tw-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-flex tw-gap-x-2 tw-items-center tw-text-secondary-70 tw-font-medium",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Avatar */.qE, {
                                                                    src: (ref6 = videos[0]) === null || ref6 === void 0 ? void 0 : ref6.live_streamer.avatar,
                                                                    className: "tw-w-6 tw-h-6",
                                                                    rounded: "tw-rounded-full"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                    dangerouslySetInnerHTML: {
                                                                        __html: (ref7 = videos[0]) === null || ref7 === void 0 ? void 0 : ref7.live_streamer.name
                                                                    }
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "tw-text-secondary-10 tw-ml-5",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: (0,dayjs/* humanDate */.rN)((ref8 = videos[0]) === null || ref8 === void 0 ? void 0 : ref8.start_datetime)
                                                                }),
                                                                "|",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: (ref9 = videos[0]) === null || ref9 === void 0 ? void 0 : ref9.duration
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tw-grid tw-grid-cols-2 tw-gap-2 md:tw-gap-4",
                                    children: category && category.products.length > 0 && category.products.slice(0, 4).map(function(p) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductLoop/* ProductLoop */._, {
                                            p: p,
                                            t: t
                                        }, "product-".concat(p.product_code));
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var partials_NewLive = (/*#__PURE__*/(0,react.memo)(NewLive));

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95298);
// EXTERNAL MODULE: ./contexts/profile/index.tsx
var profile = __webpack_require__(48309);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(13390);
;// CONCATENATED MODULE: ./features/home/layout.tsx

















var HomePageLayout = function(param) {
    var sliders = param.sliders, categories = param.categories;
    var ref, ref1, ref2, ref3, ref4;
    var ReferralDefault = {
        isShow: false,
        referrer: null
    };
    var masterData = (0,profile/* useMasterData */.AE)();
    var theme = (masterData !== null && masterData !== void 0 ? masterData : {}).theme;
    var web_bg_news_url = (theme !== null && theme !== void 0 ? theme : {}).web_bg_news_url;
    var t = (0,esm/* useTranslation */.$G)("layout").t;
    var ref5 = (0,react.useState)(ReferralDefault), data = ref5[0], setData = ref5[1];
    (0,react.useEffect)(function() {
        var data = localStorage.getItem("referrer");
        if (data) {
            setData(JSON.parse(data));
            localStorage.removeItem("referrer");
        }
    }, []);
    var closeModal = function() {
        setData(ReferralDefault);
    };
    if (!masterData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTag/* default */.Z, {
                title: (masterData === null || masterData === void 0 ? void 0 : (ref = masterData.company_info) === null || ref === void 0 ? void 0 : ref.title) || "An Thư The Diamond Store",
                description: (masterData === null || masterData === void 0 ? void 0 : (ref1 = masterData.company_info) === null || ref1 === void 0 ? void 0 : ref1.description) || "An Thư The Diamond Store",
                image: "".concat("https://anthu.vn", "/logo-bg.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "tw-hidden",
                children: "An Thư The Diamond Store"
            }),
            !!sliders.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "index-slider",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_HomeSlider, {
                    images: sliders
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "tw-py-6 md:tw-py-10",
                children: (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Categories, {
                    categories: categories
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_FlashSale, {
                title: t("main.flash-sale"),
                theme: theme,
                t: t
            }),
            (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home) && (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[0]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container tw-mx-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProducts, {
                    isSale: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[0].isSale,
                    title: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[0].title,
                    catCode: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[0].code,
                    theme: theme,
                    t: t
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(partials_NewLive, {
                title: "Trực tiếp",
                theme: theme,
                t: t
            }),
            (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home) && (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[1]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container tw-mx-auto tw-mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProducts, {
                    isSale: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[1].isSale,
                    title: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[1].title,
                    catCode: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[1].code,
                    theme: theme,
                    t: t
                })
            }),
            (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home) && (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[2]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "container tw-mx-auto tw-mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewProducts, {
                    isSale: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[2].isSale,
                    title: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[2].title,
                    catCode: masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[2].code,
                    theme: theme,
                    t: t
                })
            }),
            (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home) && (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[3]) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "doi-tac-an-thu",
                className: "tw-mt-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Partners, {
                    title: (masterData === null || masterData === void 0 ? void 0 : masterData.categories_home[3].title) || t("main.partners")
                })
            }),
            (masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs[0].id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "tw-w-full tw-mt-12 tw-bg-cover tw-bg-no-repeat tw-bg-center",
                style: {
                    backgroundImage: web_bg_news_url ? "url(".concat(web_bg_news_url, ")") : 'url("/bg-live.svg")'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "article container tw-pt-10 tw-mx-auto md:tw-pb-12",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Articles, {
                        title: t("main.news"),
                        t: t,
                        id: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs[0].id,
                        slug: masterData === null || masterData === void 0 ? void 0 : masterData.menu_blogs[0].slug,
                        theme: theme
                    })
                })
            }),
            data.isShow && data.referrer && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Modal */.u_, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* ModalBody */.fe, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-font-semibold",
                            children: "Th\xf4ng b\xe1o ch\xfac mừng"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "tw-mt-2",
                            children: [
                                "Ch\xfac mừng bạn đ\xe3 tạo th\xe0nh c\xf4ng t\xe0i khoản mới theo lời giới thiệu của ",
                                (ref2 = data.referrer) === null || ref2 === void 0 ? void 0 : ref2.fullname,
                                " -",
                                " ",
                                (0,app/* toPhoneNumberNational */._J)((ref3 = data.referrer) === null || ref3 === void 0 ? void 0 : ref3.phone, (ref4 = data.referrer) === null || ref4 === void 0 ? void 0 : ref4.country, true)
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Button */.zx, {
                            className: "tw-bg-primary-main tw-text-white tw-text-lg tw-mt-8 !tw-rounded-full",
                            onClick: function() {
                                return closeModal();
                            },
                            children: "OK"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var layout = (HomePageLayout);

;// CONCATENATED MODULE: ./features/home/index.ts

/* harmony default export */ var home = (layout);

;// CONCATENATED MODULE: ./pages/index.tsx



var HomePage = function(param) {
    var sliders = param.sliders, categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(home, {
        sliders: sliders,
        categories: categories
    });
};
var __N_SSP = true;
/* harmony default export */ var pages = (HomePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2004,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);